export const STORES = {
  APPLE: "https://apps.apple.com/us/app/vecinos-app/id1587216509",
  GOOGLE: "https://play.google.com/store/apps/details?id=com.vecinosui",
};

export const SOCIAL_NETWORKS = {
  facebook: "https://www.facebook.com/Vecinos-App-108615131727652",
  instagram: "https://www.instagram.com/vecinos.app/",
};
